import {EditElementModalForm} from "../EditElementModalForm";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {FacebookLogo} from "../logos/FacebookLogo";
import {GoogleLogo} from "../logos/GoogleLogo";
import React from "react";
import {SheetLogo} from "../logos/SheetLogo";
import {TiktokLogo} from "../logos/TiktokLogo";
import {LinkedinLogo} from "../logos/LinkedinLogo";

export class CampaignsNotAssignedForm extends EditElementModalForm {

    constructor(props) {
        super(props);
        this.state = {
            campaignsNotAssigned: null,
            loading: true,
            saving: false,
            snoozeSelectsData: {},
            undoSnoozeChecksData: {}
        };

        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleOptionChange = this.handleOptionChange.bind(this);
    }

    componentDidMount() {
        this.getCampaignsNotAssigned();
    }

    getCampaignsNotAssigned() {
        new APIClient(API_URL + `business-unit/${this.props.businessUnitId}/campaigns-not-assigned/`).call('GET').then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {
                this.setState({
                    campaignsNotAssigned: data.data,
                    loading: false
                });
            }
        })
    }

    getSubmitUrl() {
        return API_URL + `business-unit/${this.props.businessUnitId}/campaigns-not-assigned/snooze-update`;
    }

    getDataToSubmit(event) {

        // Des-silenciar
        const campaignsNotAssignedToUndoSnooze = [];
        Object.entries(this.state.undoSnoozeChecksData).forEach(([checkName, value]) => {
            if(value) {
                const id = parseInt(checkName.match(/\d+/)[0], 10);
                campaignsNotAssignedToUndoSnooze.push(id);
            }
        });

        //Silenciar
        const campaignsNotAssignedToSnooze = [];
        Object.entries(this.state.snoozeSelectsData).forEach(([selectName, value]) => {
            if(value) {
                const id = parseInt(selectName.match(/\d+/)[0], 10);
                const date = this.getDateToSnoozeConsideringSelectOption(value)
                campaignsNotAssignedToSnooze.push({'campaign_not_assigned_id':id, 'snooze_until':date});
            }
        });


        return {
            data_to_snooze: campaignsNotAssignedToSnooze,
            data_to_undo_snooze: campaignsNotAssignedToUndoSnooze
        };
    }

    getDateToSnoozeConsideringSelectOption(selectOption) {
        if(selectOption==="1")
            return null;

        if(selectOption==="2")
            return this.formatDateToYYYYMMDD(this.addDaysToCurrentDate(1));

        if(selectOption==="3")
            return this.formatDateToYYYYMMDD(this.addDaysToCurrentDate(7));

        if(selectOption==="4")
            return '2777-01-01';
    }

    addDaysToCurrentDate(days) {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + days);
        return currentDate;
    }

    renderSaveButton() {
        if (this.state.saving === false) {
            return <input type="submit" value="Guardar" className="btn -submit"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    renderFormFields() {
        if (this.state.loading) {
            return <div className="box-loader">
                <Spinner color="positive"/>
            </div>
        }

        return <div className="modal-section">
            <table className="table table-hover campaigns-alert-table">
                <thead>
                <tr>
                    <th>Cuenta</th>
                    <th>Campaña</th>
                    <th></th>
                </tr>
                </thead>
                <tbody>
                {this.renderCampaigns()}
                </tbody>
            </table>
        </div>
    }

    renderChannelIcon(campaignNotAssignedData) {
        if (!campaignNotAssignedData)
            return;

        if (campaignNotAssignedData.channel === 'FACEBOOK')
            return <FacebookLogo/>;

        if (campaignNotAssignedData.channel === 'GOOGLE')
            return <GoogleLogo height={"13"} width={"13"}/>;

        if (campaignNotAssignedData.channel === 'SHEET')
            return <SheetLogo height={"13"} width={"13"}/>;

        if (campaignNotAssignedData.channel === 'TIKTOK')
            return <TiktokLogo height={"13"} width={"13"}/>;

        if (campaignNotAssignedData.channel === 'LINKEDIN')
            return <LinkedinLogo height={"13"} width={"13"}/>;
        throw new Error('Channel ' + campaignNotAssignedData.channel + ' not supported');
    }

    handleCheckChange(event) {
        const undoSnoozeChecksData = this.state.undoSnoozeChecksData;
        undoSnoozeChecksData[event.target.name] = event.target.checked;
        this.setState({ undoSnoozeChecksData: undoSnoozeChecksData });
    }

    handleOptionChange = (event) => {
        const snoozeSelectsData = this.state.snoozeSelectsData;
        snoozeSelectsData[event.target.name] = event.target.value;
        this.setState({ snoozeSelectsData: snoozeSelectsData });
    };

    convertDateFormat(dateString) {
        // Convierte yyyy-mm-dd en dd/mm/yyyy
        const parts = dateString.split("-");
        return `${parts[2]}/${parts[1]}/${parts[0]}`;
    }

    formatDateToYYYYMMDD(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    renderSnoozeCell(campaignNotAssignedData) {

        if (this.isDateTodayOrFuture(campaignNotAssignedData.snoozed_until)) {
            const checkName = `undo-snooze-${campaignNotAssignedData.campaign_not_assigned_id}`
            const snoozeText = `Silenciado ${campaignNotAssignedData.snoozed_until === '2777-01-01'?'para siempre':'hasta '+this.convertDateFormat(campaignNotAssignedData.snoozed_until)}`
            return <p>{snoozeText}<br/><div style={{color:"rgb(135 135 135)"}}>(<input style={{width:"auto", height:"auto"}} type="checkbox" id={checkName} name={checkName} onChange={this.handleCheckChange} />{' '}Volver a alertar)</div></p>
        }

        const selectName = `snooze-${campaignNotAssignedData.campaign_not_assigned_id}`

        return <select id="combo-input" name={selectName} value={this.state.snoozeSelectsData[selectName]} onChange={this.handleOptionChange}>
            <option value="1">Alerta activada</option>
            <option value="2">Silenciar por 1 día</option>
            <option value="3">Silenciar por 1 semana</option>
            <option value="4">Silenciar para siempre</option>
        </select>

    }

    isDateTodayOrFuture(dateString) {
        if(!dateString)
            return false;

        // Convert the date string to a Date object
        const date = new Date(dateString);

        // Get the current date
        const currentDate = new Date();

        // Remove the time part from the current date
        currentDate.setHours(0, 0, 0, 0);

        // Compare the dates
        return date >= currentDate;
    }

    renderCampaigns() {
        if (!this.state.campaignsNotAssigned)
            return;

        return this.state.campaignsNotAssigned.map((campaignNotAssignedData) => {
            return (
                <tr>
                    <td>{this.renderChannelIcon(campaignNotAssignedData)}{campaignNotAssignedData.account_name} [{campaignNotAssignedData.platform_account_id}]</td>
                    <td>{campaignNotAssignedData.campaign_name}</td>
                    <td>{this.renderSnoozeCell(campaignNotAssignedData)}</td>
                </tr>
            )
        })
    }
}
